import axios from 'axios';
import { getAppToken, getSelfToken } from '../_helpers/auth/secureToken';
const BASE_URL = process.env.REACT_APP_BASEURL;

class APIService {
  constructor(baseURL) {
    this.baseURL = baseURL || BASE_URL;
    this.api = axios.create({
      baseURL: this.baseURL
    });

    // Define your endpoints here
    this.endpoints = {
      industryList: 'brand/industry/',
      saveProfile: 'brand/users',
      eventList: 'brand/events',
      deliverables: 'brand/deliverables/',
      brand_event: 'brand/brand_event',
      brand_event_view: 'brand/events',
      brand_event_submission: 'brand/brand_events/',
      brand_event_submission_view: 'brand/brand_event/view/',
      eventsType :'brand/events_type',
      // --------- offer ----
      brand_offers: 'brand/offers',
      offers_creation: 'brand/offers_creation/',
      offers_updation: 'brand/offers_updation/',
      offers_requirements: 'brand/offers_requirements/',
      offers_eligible: 'brand/offers_eligible/',

      // ------------ gig-management ---------
      gigs: 'brand/gigs/',
      gigsview: 'brand/gigs',
      gigscreate: 'brand/gigs_creation/',
      gigs_updation: 'brand/gigs_updation/',
      gigsType: 'brand/gigs_type/',

      // ------------ internship-management ---------
      internships: 'brand/internships/',
      internshipsview: 'brand/internships',
      intershipType: 'brand/internship_type/',
      intershipSkills: 'brand/skills/',
      intershipBenefit: 'brand/benefits/',
      Internshipscreate: 'brand/internship_creation/',
      internship_updation: 'brand/internship_updation/',

      // ----------- d3chart
      offerApplicantClick: 'brand',

      // ---new offer campaign type

      campaigntype:'brand/campaign_type',
      offer_category:'brand/offer-category/',
      audience_type:'brand/audience-type/',
      influencer_tier:'brand/influencer-tier/',
      city:'brand/city/',
      target_audience:'brand/target-audience/',
      platform:'brand/platform/',
      content_requirements:'brand/content-requirements',
      barterCampaign:'brand/barter-campaign',
      product_images:"brand/product-images/",
      reference_links:'brand/reference-link',
      all_campaigns:'brand/all_campaigns',
      all_submissions:'brand/all_submissions',
      update_submission:'brand/update_submission',
      submit_rating_creator:'brand/submit_rating_creator/',
      all_ratings:"brand/all_ratings",
      deliverable_links: 'brand/deliverable_links',
      live_links: 'brand/live_links',
      update_rating_creator:'brand/update_rating_creator',
      get_rating_creator:'brand/get_rating_creator',
      barterApplicantClick:'brand',
      get_all_handles:'brand/get_all_handles',
      get_submission_handles:'brand/get_submission_handles',
      get_handle_rating:'brand/get_handle_rating',
      get_submission_stats:'brand/get_submission_stats',
      gigs_apply:'brand/gigs_apply',
      gigs_apply_updation:'brand/gigs_apply_updation',
      gigs_apply_Update:'brand/gigs_apply_updation/',
      creatorhandler:'api/auth/creatorhandler/',
      instagram_account_analytics: 'api/auth/instagram/account-analytics/',
      instagram_media_analytics: 'api/auth/instagram/media-analytics/',
      all_accounts: 'api/auth/all-accounts/',
    };
  }

  /**
   * @param {object} [config] passed through to axios — notably `signal`, so a
   *   caller can abort an in-flight request (e.g. a component unmounting).
   */
  async get(endpointKey, params = {}, searchParam = null, config = {}) {
    try {
      let endpoint = this.endpoints[endpointKey];
      if (searchParam) {
        endpoint = endpoint + '/' + searchParam;
      }
      params.app = getAppToken();

      const response = await this.api.get(endpoint, {
        params,
        headers: { Authorization: 'Token ' + getSelfToken() },
        ...config,
      });
      return response;
    } catch (error) {
      // A cancellation is the caller's own doing, not a failure — propagate it
      // unwrapped so it stays distinguishable from a genuine request error.
      if (axios.isCancel(error)) {
        throw error;
      }
      throw new Error('API request failed:', error);
    }
  }

  async post(endpointKey, data = null, searchParam = null) {
    try {
      let endpoint = this.endpoints[endpointKey];
      if (searchParam) {
        endpoint = endpoint + '/' + searchParam;
      }
      data.app = getAppToken();
      const response = await this.api.post(endpoint, data, {
        headers: { Authorization: 'token ' + getSelfToken() }
      });
      return response;
    } catch (error) {
      // throw new Error('API request failed:', { error });
      return error.response;
    }
  }
  async delete(endpointKey, params = {}, searchParam = null) {
    try {
      let endpoint = this.endpoints[endpointKey];
      if (searchParam) {
        endpoint = endpoint + '/' + searchParam;
      }
      params.app = getAppToken();
      const response = await this.api.delete(endpoint, {
        params,
        headers: { Authorization: 'Token ' + getSelfToken() }
      });
      return response;
    } catch (error) {
      throw new Error('API request failed:', error);
    }
  }

  async put(endpointKey, data = null, searchParam = null, pathParam = null) {
    try {
      let endpoint = this.endpoints[endpointKey];
      if (pathParam) {
        if (endpoint.endsWith('/')) {
          endpoint = `${endpoint}${pathParam}/`;
        } else {
          endpoint = `${endpoint}/${pathParam}/`;
        }
      }
      if (searchParam) {
        const searchParams = new URLSearchParams(searchParam).toString();
        endpoint = `${endpoint}?${searchParams}`;
      }

      data['app'] = getAppToken();
      const response = await this.api.put(endpoint, data, {
        headers: { Authorization: 'token ' + getSelfToken() }
      });

      return response;
    } catch (error) {
      console.log(error.response);
      return error.response;
    }
  }
}



export default new APIService(BASE_URL);
